module.exports = __webpack_public_path__ + "static/img/IMG_20241124_130515.8ac9ad5a.jpg";